export class UserChangeModel {
  email: string = '';
  password: string = '';
  carriers: Array<string> = [];
  isAdmin: boolean = false;
  isActive: boolean = true;
  isNew: boolean = true;
};
